import { usePurchaseFlowProducts, useTargetOrderUser } from 'components/pages/PurchaseFlow/_main/contexts'

import { useGetMeasurementPricing } from 'dataQueries/purchase.query'

/**
 * The only reader of the On-Site Area Report rate card.
 *
 * The card exists only in the countries that sell the product, and a missing mandatory carrier fails the
 * whole card on the backend — so asking for it where the catalogue does not carry it 404s on every
 * purchase-flow page load and buries a genuine catalogue misconfiguration under the noise. A selection is
 * the gate because nothing reads the card before one; bundled kinds count, so a package carrying the
 * measurement product still resolves its rates.
 *
 * Gating here rather than at each consumer is load-bearing: all consumers share one react-query key, so a
 * single ungated observer would re-enable the request for every one of them.
 */
export function useMeasurementRateCard() {
  const { hasMeasurementProduct } = usePurchaseFlowProducts()
  const { adminSelectedUserEmail } = useTargetOrderUser()

  return useGetMeasurementPricing(adminSelectedUserEmail || undefined, hasMeasurementProduct)
}
